import React from 'react'
import { useQuery } from '@apollo/client'
import { ProductQtyWrapper, Wrapper } from './styled'
import { getStoreConfig } from 'services/storeConfig'
import { MagentoProductPrices } from 'lib/types'

interface Props {
  qty: number
  handleQtyChange: (qty: any) => void
  packageType?: string
  packageQty?: string
  price: MagentoProductPrices
  productId: number
  frequency: number
  subtotalPrice: number
  label?: string
}
export const ProductQtyInput = ({ handleQtyChange, qty, packageType, packageQty, price, productId, frequency, subtotalPrice, label = 'Quantity' }: Props) => {
  const { data } = useQuery(getStoreConfig)
  const priceValue = price.regularPrice?.amount.value
  const freeShippingSubtotal = parseInt(data?.storeConfig?.carriers_freeshipping_free_shipping_subtotal ?? '')
  const amountToFreeShipping = getAmountToFreeShipping({ freeShippingSubtotal, priceValue, finalPrice: subtotalPrice })
  return (
    <Wrapper>
      <label>{label}</label>
      <ProductQtyWrapper>
        <div>
          <input
            type='number'
            onChange={handleQtyChange}
            value={qty}
          />
        </div>
        <span>
          {`${packageType} (${packageQty} pieces per ${packageType})`}
          {amountToFreeShipping && (
            <>
              <br />
              <small>({amountToFreeShipping} more for Free Shipping)</small>
            </>
          )}
        </span>
      </ProductQtyWrapper>
    </Wrapper>
  )
}

const getAmountToFreeShipping = ({ freeShippingSubtotal, priceValue, finalPrice }: { freeShippingSubtotal: number, priceValue: number, finalPrice: number }) => {
  const amountToFreeShipping = Math.ceil((freeShippingSubtotal - finalPrice) / priceValue)

  if (isNaN(amountToFreeShipping) || amountToFreeShipping <= 0) return undefined

  return amountToFreeShipping
}
